var dfs = require("./dfs");

module.exports = postorder;

function postorder(g, vs) {
  return dfs(g, vs, "post");
}



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/alg/postorder.js
// module id = 120
// module chunks = 0